import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';

import {
  BodyText,
  Circle,
  HeaderText,
  PortalOverlay,
  PortalOverlayHeader,
  PortalOverlayHeaderCloseBtn,
  PortalOverlayModal,
  Stack,
} from '../../../ui';
import { FinanceCreditcardFaceIcon } from '../../../ui/Icons';

type CardAuthorizationModalProps = {
  onBackdropClick: () => void;
};

export const CardAuthorizationModal: React.FC<CardAuthorizationModalProps> = (
  { onBackdropClick },
) => (
  <PortalOverlay name="deposits-info-modal" onBackdropClick={onBackdropClick}>
    <PortalOverlayModal position="fullScreen">
      <PortalOverlayHeader
        hideBottomBorder
        renderRightAction={() => (
          <PortalOverlayHeaderCloseBtn
            onCloseRequest={onBackdropClick}
            size={24}
          />
        )}
      />
      <Box padding={24} testID="styleseat-card-auth-modal">
        <Stack space={8} padding={8}>
          <Circle
            color={colors.whiteWash}
            diameter={44}
            applyShadowFilter
          >
            <FinanceCreditcardFaceIcon color="black" />
          </Circle>

          <HeaderText level={2} testID="styleseat-card-auth-modal-header">
            Your client has enough funds to cover the appointment plus tip
          </HeaderText>

          <Stack style={{ marginTop: 30 }} space={20} testID="styleseat-card-auth-modal-body">
            <BodyText>
              If clients book <BodyText weight="extra-bold">less than a week</BodyText> in advance, we
              temporarily charge their card and hold enough
              funds to cover the appointment plus tip.
            </BodyText>

            <BodyText>
              If they cancel late or no-show, we&apos;ve already
              secured your money and you&apos;ll have the option to
              collect it.
            </BodyText>

            <BodyText>
              If something comes up or you need to
              reschedule, their money will quickly be released
              back into their bank account.
            </BodyText>
          </Stack>
        </Stack>
      </Box>
    </PortalOverlayModal>
  </PortalOverlay>
);
